import React from 'react';

import { PageLayout } from 'src/components/common';
import { spacingStyling } from 'src/constants/spacing';
import { useFilterStorage } from 'src/hooks/common';
import { usePeoPayrollProviderStaffsList } from 'src/hooks/peoPayrollProviderStaff/usePeoPayrollProviderStaffList';
import { useCurrentUserStaff } from 'src/hooks/user';
import { SxProp } from 'src/types/mui';

import { PeoPayrollProviderStaffTable } from './components';

export const PeoPayrollProviderStaffWrapper = () => {
  const { peoPayrollProviderStaff } = useCurrentUserStaff();
  const peoPayrollProviderId = peoPayrollProviderStaff?.peoPayrollProvider.id;

  const { sortQueryVariable, paginationQueryVariables, pagination } = useFilterStorage();

  const { peoPayrollProviderStaffsCount, peoPayrollProviderStaffsList, loading, refetch } =
    usePeoPayrollProviderStaffsList(
      {
        filter: {
          peoPayrollProviderId: { equals: peoPayrollProviderId },
        },
        ...paginationQueryVariables,
        orderBy: sortQueryVariable,
      },
      true,
    );

  const refetchData = React.useCallback(async () => {
    await refetch();
    pagination.resetPage();
  }, [pagination, refetch]);

  return (
    <PageLayout titleContent="Staff" paperSx={pageLayoutPaperSx}>
      <PeoPayrollProviderStaffTable
        peoPayrollProviderId={peoPayrollProviderId}
        loading={loading}
        peoPayrollProviderStaffCount={peoPayrollProviderStaffsCount}
        peoPayrollProviderStaffList={peoPayrollProviderStaffsList}
        pagination={pagination}
        onRefresh={refetchData}
      />
    </PageLayout>
  );
};

const pageLayoutPaperSx: SxProp = {
  p: spacingStyling.peoTable,
  mt: 3,
};
